export const GET_LIST_BEGIN = "GET_LIST_BEGIN";
export const GET_LIST_SUCCESS = "GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "GET_LIST_FAIL";

export const POST_LIST_BEGIN = "POST_LIST_BEGIN";
export const POST_LIST_SUCCESS = "POST_LIST_SUCCESS";
export const POST_LIST_FAIL = "POST_LIST_FAIL";

export const DELETE_LIST_BEGIN = "DELETE_LIST_BEGIN";
export const DELETE_LIST_SUCCESS = "DELETE_LIST_SUCCESS";
export const DELETE_LIST_FAIL = "DELETE_LIST_FAIL";

export const EDIT_LIST_BEGIN = "EDIT_LIST_BEGIN";
export const EDIT_LIST_SUCCESS = "EDIT_LIST_SUCCESS";
export const EDIT_LIST_FAIL = "EDIT_LIST_FAIL";

export const GET_TRACKER_STATUS_BEGIN = "GET_TRACKER_STATUS_BEGIN";
export const GET_TRACKER_STATUS_SUCCESS = "GET_TRACKER_STATUS_SUCCESS";
export const GET_TRACKER_STATUS_FAIL = "GET_TRACKER_STATUS_FAIL";

export const EDIT_STATUS_BEGIN = "EDIT_STATUS_BEGIN";
export const EDIT_STATUS_SUCCESS = "EDIT_STATUS_SUCCESS";
export const EDIT_STATUS_FAIL = "EDIT_S TATUS_FAIL";

export const GET_PIC_BEGIN = "GET_PIC_BEGIN";
export const GET_PIC_SUCCESS = "GET_PIC_SUCCESS";
export const GET_PIC_FAIL = "GET_PIC_FAIL";

export const GET_TALENT_BEGIN = "GET_TALENT_BEGIN";
export const GET_TALENT_SUCCESS = "GET_TALENT_SUCCESS";
export const GET_TALENT_FAIL = "GET_TALENT_FAIL";

export const GET_COMPANY_BEGIN = "GET_COMPANY_BEGIN";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAIL = "GET_COMPANY_FAIL";

export const POST_TRACKER_BEGIN = "POST_TRACKER_BEGIN";
export const POST_TRACKER_SUCCESS = "POST_TRACKER_SUCCESS";
export const POST_TRACKER_FAIL = "POST_TRACKER_FAIL";
